export default function Emergency() {
  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-r from-teal-600 to-teal-400"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-full mb-6 animate-pulse">
            <i className="ri-alarm-warning-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Water Damage Emergency?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Don't wait! Every minute counts when dealing with water damage. Our emergency response team is standing by 24/7 to help you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a href="tel:2094512288" className="bg-teal-600 text-white px-10 py-5 rounded-lg text-xl font-bold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              Call (209) 451-2288
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="text-4xl font-bold text-teal-400 mb-2">1</div>
              <h4 className="text-white font-semibold mb-2">Call Us</h4>
              <p className="text-gray-400 text-sm">Contact our 24/7 emergency line</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="text-4xl font-bold text-teal-400 mb-2">2</div>
              <h4 className="text-white font-semibold mb-2">Fast Response</h4>
              <p className="text-gray-400 text-sm">We arrive quickly to assess damage</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="text-4xl font-bold text-teal-400 mb-2">3</div>
              <h4 className="text-white font-semibold mb-2">Begin Work</h4>
              <p className="text-gray-400 text-sm">Immediate water extraction starts</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="text-4xl font-bold text-teal-400 mb-2">4</div>
              <h4 className="text-white font-semibold mb-2">Full Restoration</h4>
              <p className="text-gray-400 text-sm">Complete restoration to pre-damage condition</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
